import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export interface PendingLoginValidation {
  tempUserId: string;
  tempPass: string;
}

@Injectable({ providedIn: "root" })
export class PendingLoginValidationService {
  private readonly pendingValidation$ =
    new BehaviorSubject<PendingLoginValidation | null>(null);

  public readonly value$ = this.pendingValidation$.asObservable();

  public set(value: PendingLoginValidation): void {
    if (!value?.tempUserId || !value?.tempPass) {
      return;
    }

    this.pendingValidation$.next({
      tempUserId: value.tempUserId,
      tempPass: value.tempPass,
    });
  }

  public peek(): PendingLoginValidation | null {
    return this.pendingValidation$.value;
  }

  public clear(): void {
    this.pendingValidation$.next(null);
  }
}
